export default __webpack_public_path__ + "static/2. Parent Engagement at Your Fingertips 1-c8af0ef767ef8d19a2f916c2cd3ffd98.jpg";